import type { Page } from '../../types';
const fairAndOpen: Page[] = [
  {
    pageType: 'question',
    title: 'Breakdown',
    name: 'fair-and-open',
    hidePageTitle: true,
    description:
      'This question asks for a breakdown, by grade, of the number of individuals recruited externally, through fair and open competition ' +
      '',
    hideContinueButton: true,
    navigateToSummaryOnComplete: true,
    questions: [
      {
        questionType: 'inset',
        title: '',
        insetContent:
          'You reported ${1} people recruited through fair and open competition.<br><br>' +
          'Please provide a grade breakdown of these people here.<br><br>',
        insetVariables: {
          1: {
            type: 'previousAnswer',
            key: 'headline-fair-and-open',
          },
        },
        name: 'external-recruit-fairandopen-inset',
        detailsContent: 'Fair and Open inset detail',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'fairAndOpenInput',
        title: 'Breakdown',
        name: 'fair-and-open-grade-column',
        detailsHeading: 'More information',
        label: 'Externally recruited individuals',
        detailsContent: 'If the grade does not align directly you can use the equivalent',
        rules: {
          required: true,
        },
        customValidation: {
          sumEqualToPreviousAnswer: 'headline-fair-and-open',
        },
      },
    ],
  },
];
export default fairAndOpen;
